// eslint-disable-next-line import/no-named-as-default
import Icon from "@mdi/react";
import * as Sentry from "@sentry/react";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

import { mdiFilter, mdiFilterOutline } from "@mdi/js";
import { Button, Tooltip } from "antd";
import {
  setFilterToSystemDefault,
  setFilterState as setWellFilterState,
  setSelectedSavedFilter as setWellSelectedSavedFilter
} from "store/features/filter/filterSlice";
import { useMapStore } from "stores/map";

interface IApplyFilterButton {
  filterJSON: string;
  setErrorMessage: React.Dispatch<React.SetStateAction<Maybe<string>>>;
  isActive: boolean;
  changeId: string;
  onToggleActive: (changeId: Maybe<string>) => void;
  onClearWellList: () => void;
}

export const ApplyFilterButton = function ({
  filterJSON,
  setErrorMessage,
  isActive,
  changeId,
  onToggleActive,
  onClearWellList
}: IApplyFilterButton) {
  const dispatch = useDispatch();
  const setViewLock = useMapStore((s) => s.setViewLock);

  const toggleFilter = useCallback(() => {
    try {
      if (isActive) {
        dispatch(setFilterToSystemDefault());
        onToggleActive(null);
        setViewLock(false);
        toast.success("Filter removed");
      } else {
        const filterObject = { name: "Active Filter", id: "", filterId: "", filterJSON };
        dispatch(setWellSelectedSavedFilter(filterObject));

        const fil = JSON.parse(filterJSON);
        if (fil.polygonFilter) {
          setViewLock(true);
        } else {
          setViewLock(false);
        }

        dispatch(setWellFilterState(fil));
        onToggleActive(changeId);
        onClearWellList();
        toast.success("Filter applied!");
      }
      setErrorMessage(undefined);
    } catch (error) {
      toast.error("Error applying filter.");
      setErrorMessage("Error applying filter. Invalid filter format.");
      Sentry.captureException(error);
    }
  }, [
    filterJSON,
    dispatch,
    setErrorMessage,
    isActive,
    changeId,
    onToggleActive,
    onClearWellList
  ]);

  return (
    <Tooltip title={isActive ? "Remove Filter" : "Apply Filter"}>
      <Button
        data-testid="applyFilterBtn"
        onClick={toggleFilter}
        className={isActive ? "active" : ""}>
        <Icon
          path={isActive ? mdiFilter : mdiFilterOutline}
          className="activity-action-icon"
          size={1}
        />
      </Button>
    </Tooltip>
  );
};
